/**
 * Whether a broker group id that doesn't exist looks like Excel changed it when a cell was
 * dragged down: it ends in a number, and another id in the file is the same apart from a
 * different number at the end (Excel counts up a trailing number as it fills cells).
 * Kept the same as the backend's services/validation/userImport.js.
 *
 * @param {string} id
 * @param {string[]} fileIds every broker group id in the file
 */
export const looksDraggedDown = (id, fileIds) => {
	const stem = id.replace(/\d+$/, '');
	return (
		stem !== id &&
		fileIds.some(
			(other) => other !== id && other.startsWith(stem) && /^\d+$/.test(other.slice(stem.length)),
		)
	);
};
